import React from 'react'
import { createRoot } from 'react-dom/client'

import AppProviders from './AppProviders'
import App from './App'

import { store, history } from './store'

import '../sass/main.scss'
import 'font-awesome/css/font-awesome.css'

window.apigClient = window.apigClientFactory.newClient({ region: 'us-east-1' })

const config = {
  maintenance: !!OE_ENV.MAINTENANCE_MODE && OE_ENV.MAINTENANCE_MODE === 'true',
}

const container = document.getElementById('root')
const root = createRoot(container)

if (store) {
  root.render(
    <AppProviders store={store} history={history}>
      <App maintenance={config.maintenance} />
    </AppProviders>,
  )
} else {
  console.error('App cannot render: Store is undefined');
}
